export {GetQueryString, getCookie, signOut}

// 获取地址栏参数
function GetQueryString (param) {
  var currentUrl = window.location.href
  var arr = currentUrl.split('?')
  if (arr.length > 1) {
    arr = arr[1].split('&') // 分割参数
    for (var i = 0; i < arr.length; i++) {
      var tem = arr[i].split('=') // 分割参数名和参数内容
      if (tem[0] === param) {
        return tem[1]
      }
    }
    return null
  } else {
    return null
  }
}

// 获取cookie
function getCookie (name) {
  if (!document.cookie || document.cookie === '') {
    return false
  } else {
    var cookieValue = null
    var cookies = document.cookie.split(';')
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
    return cookieValue
  }
}

// 退出
function signOut () {
  sessionStorage.clear()
  localStorage.clear()
  this.$api.signOut({}).then(res => {
    document.cookie = 'user_Name=;expires=-1; path=/'
    this.$router.go(0)
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/common/common.js